import React, {useEffect, useState} from 'react';
import Cookie from 'js-cookie';
import DocAvatar from '@/components/CustomImg';
import {host} from '@/utils/hostConf';
import {locationTo, decodeSign} from '@utils/tools';
import {isWeiXin} from '@utils/weixin';
import Img1 from '@/assets/icons/e-guoyidashi-icon.png';
import Img2 from '@/assets/icons/e-quanguomingzhongyi-icon.png';
import Img3 from '@/assets/icons/e-shengmingzhongyi-icon.png';
import Img4 from '@/assets/icons/e-shimingzhongyi-icon.png';

import './index.less';

function renderHonor(honor) {
  let sHonor = '',
    img = null;
  if (typeof honor == 'string' && honor !== '') {
    sHonor = honor;
  } else if (Array.isArray(honor) && honor.length) {
    sHonor = honor[0].name;
  } else {
    return null;
  }
  switch (sHonor) {
    case '国医大师':
      img = <img src={Img1} alt="" />;
      break;
    case '全国名中医':
      img = <img src={Img2} alt="" />;
      break;
    case '省名中医':
      img = <img src={Img3} alt="" />;
      break;
    case '市名中医':
      img = <img src={Img4} alt="" />;
      break;
    default:
      img = null;
  }
  return <div className="doc-label-wrp">{img}</div>;
}

function TagBtn({reg_state, doctor_sign, doctor_sign_extension, reg_offline_state, reg_video_state}) {
  const [text, setText] = useState({clinic: '', video: ''});
  const fastVideoSign = decodeSign(doctor_sign_extension, 11);
  useEffect(() => {
    if (+reg_state) {
      if (decodeSign(doctor_sign, 7)) {
        setText({
          clinic: '分院看诊',
          video: '视频看诊',
        });
      } else if (decodeSign(doctor_sign, 11)) {
        setText({
          clinic: +reg_state === 1 ? '排队预约' : '约满排队',
          video: '',
        });
      } else {
        setText({
          clinic: '电话预约',
          video: '',
        });
      }
    } else {
      setText({
        clinic: '暂无排期',
        video: '',
      });
    }
  }, [reg_state, doctor_sign]);

  return (
    <>
      <span className={`tag yellow ${+reg_offline_state ? '' : 'disabled'}`}>{text.clinic}</span>
      {text.video && <span className={`tag pink ${+reg_video_state ? '' : 'disabled'}`}>{text.video}</span>}
      <span className={`tag blue ${fastVideoSign ? '' : 'disabled'}`}>即刻视频看诊</span>
    </>
  );
}

const DocItem = function (props) {
  // console.log(333, props.data);
  const {hideTag, data, isOmo} = props;
  const {
    doctor_id,
    doctor_img,
    honor,
    doctor_name,
    doctor_title,
    doc2dept_list,
    doctor_hospital,
    good_at,
    total_comment,
    treat_num,
    reg_offline_state,
    reg_state,
    reg_video_state,
    doctor_sign,
    doctor_sign_extension,
  } = data;
  const tagBtnProps = {
    reg_state,
    doctor_sign,
    doctor_sign_extension,
    reg_offline_state,
    reg_video_state,
  };

  const onRoute = url => {
    if (isWeiXin() && isOmo) {
      let wx = window.wx || {};
      wx.miniProgram.getEnv(function (res) {
        if (res.miniprogram) {
          //H5向小程序传值的方法会在特定的时间触发，因此需要我们手动写一个跳转（也可以写后退和摧毁，分享，以需求而定）
          wx.miniProgram.navigateTo({
            url: `/pages/mobileView/index?url=${encodeURIComponent(location.origin + url)}`, //这里是小程序页面
          });
        } else {
          //非小程序环境下逻辑
          console.log('不在小程序中');
        }
      });
    } else {
      locationTo(url);
    }
  };

  return (
    <section className="doctor" onClick={() => onRoute(`/doctorinfo/${doctor_id}`)}>
      <DocAvatar src={`${host.dr_img}${doctor_img}`} extra={renderHonor(honor)} />
      <div className="info fz-28 color-grey">
        <div className="row">
          <span className="doc-name fz-36 color-black">{doctor_name}</span>
          <span className="doc-position ml-20">{doctor_title}</span>
        </div>
        {doctor_hospital ? (
          <div className="row">
            <span>{doctor_hospital}</span>
            {/*<span className="ml-20">{doc2dept_list[0]}</span>*/}
          </div>
        ) : null}
        {hideTag ? null : (
          <div className="row fz-22">
            <TagBtn {...tagBtnProps} />
          </div>
        )}
        <div className="row good_at text-flow-ellipsis-multiple">擅长：{good_at}</div>
        {decodeSign(doctor_sign, 27) ? null : (
          <div className="row other d-flex">
            <div>
              <span className="color-lightgrey">口碑 </span>
              <span className="color-red">{total_comment}</span>
            </div>
            {/* <div className="ml-20">
              <span className="color-lightgrey">接诊量 </span>
              <span className="color-red">{treat_num}</span>
            </div> */}
          </div>
        )}
      </div>
    </section>
  );
};

export default DocItem;
